// removed by extract-text-webpack-plugin
module.exports = {"messagesContainer":"_2dYFNr7ws6mNekCSD3rmhw","messagesWrapper":"QUD_VrodHw8ESrjbYjlrB","messagesItem":"_2xze3Oth9qY800ZPWIRpk3","message":"_1AJQmsm0IphulA-0kvVBnH","ani":"_1ZNiCjNM_5S-LHPPNRQTH4","userPhoto":"_3A8x8HxdDm-AvWMVnf9mr8","userName":"PKefHR2RsZ58H8sIFZsaN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FacebookTestimonialsContainer/FacebookTestimonialsContainer.scss
// module id = 1784
// module chunks = 0